/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { ReactElement, useEffect, useState } from "react"
import Breadcrumb from "components/views/atoms/Breadcrumb"
import BreadcrumbsHeader from "components/views/atoms/BreadcrumbsHeader"
import { MasterLayout } from "components/views/atoms/layouts/MasterLayout"
import TwoColumnRightPrimary from "components/views/atoms/layouts/TwoColumnRightPrimary"
import { getTalkToCarrotRefreshCarrotPlanGuidance } from "../../lib/contentful/contentfulClient"
import { useHistory } from "react-router"
import { GuidanceElement } from "../../lib/contentful/components/GuidanceElement"
import { talkToCarrotSource } from "../../components/talk-to-carrot/send-message/SendMessageUtil"
import { SendMessage } from "../../components/talk-to-carrot/send-message/SendMessage"
import { TalkToCarrotLegal } from "../../components/talk-to-carrot/TalkToCarrotLegal"
import {
  useGetDaysSinceLastUnlock,
  useGetHasCarrotPlanCreatedWithin90DaysOfUnlockAnniversary
} from "../../components/carrot-plans/case-rate-renewals/useQueryCaseRateRenewals"
import { Container, Text, TextLink } from "@carrotfertility/carotene"
import { NonStaleDoneUsingCarrotModal } from "../../components/carrot-plans/case-rate-renewals/NonStaleDoneUsingCarrotModal"
import { useSelector } from "react-redux"
import { getPreferredLocale } from "../../reducers/userInfo"
import { useIntl, FormattedMessage } from "react-intl"

const RefreshCarrotPlan = ({ breadcrumbs, baseUrl }) => {
  const history = useHistory()
  const [guidance, setGuidance] = useState<ReactElement<typeof GuidanceElement>>(null)
  const helpPath = `${baseUrl}/refresh-carrot-plan`
  const {
    data: hasCarrotPlanCreatedWithin90DaysOfUnlockAnniversary
  } = useGetHasCarrotPlanCreatedWithin90DaysOfUnlockAnniversary()
  const { data: daysSinceLastUnlock } = useGetDaysSinceLastUnlock()
  const showDoneForNowCopy =
    hasCarrotPlanCreatedWithin90DaysOfUnlockAnniversary && daysSinceLastUnlock >= 335 && daysSinceLastUnlock < 365
  const [openDoneUsingCarrotModal, setOpenDoneUsingCarrotModal] = React.useState(false)
  const preferredLocale = useSelector(getPreferredLocale)
  const intl = useIntl()
  const breadcrumbTitle = intl.formatMessage({
    defaultMessage: "Refresh Carrot Plan"
  })
  const textLinkMessage = intl.formatMessage({
    defaultMessage: "let us know"
  })

  useEffect(() => {
    const loadGuidance = async () => {
      const guidance = await getTalkToCarrotRefreshCarrotPlanGuidance(preferredLocale)
      setGuidance(<GuidanceElement guidance={guidance} />)
    }
    if (!guidance) {
      loadGuidance()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- See https://carrotfertility.atlassian.net/wiki/spaces/PE/pages/2050295461/Remove+Build+Warnings#react-hooks%2Fexhaustive-deps
  }, [])

  return (
    <MasterLayout
      footer={<TalkToCarrotLegal />}
      header={
        <BreadcrumbsHeader
          breadcrumbs={[
            ...breadcrumbs,
            <Breadcrumb key="help-breadcrumb" title={breadcrumbTitle} isActive onClick={() => history.push(helpPath)} />
          ]}
        />
      }
    >
      <TwoColumnRightPrimary
        secondaryContent={
          <>
            <Container stack={"medium"}>{guidance}</Container>
            {showDoneForNowCopy ? (
              <Text size={"small"} color={"black60"}>
                <FormattedMessage defaultMessage="Or if you're done using Carrot, " />
                <TextLink color={"black60"} onClick={() => setOpenDoneUsingCarrotModal(true)}>
                  {textLinkMessage}
                </TextLink>
              </Text>
            ) : null}
          </>
        }
        primaryContent={<SendMessage source={talkToCarrotSource.REFRESH_CARROT_PLAN} />}
      />
      <NonStaleDoneUsingCarrotModal {...{ openDoneUsingCarrotModal, setOpenDoneUsingCarrotModal }} />
    </MasterLayout>
  )
}

export { RefreshCarrotPlan }
